import '../../i18n/autoTranslate';
// [NEW] WelcomeBannerSkeleton.jsx
// Shows while `user` is null to avoid the jarring "___ ___" placeholder.

import React from "react";

const SkeletonBlock = ({ className = "" }) => (
  <div className={`animate-pulse rounded-xl bg-white/10 ${className}`} />
);

export default function WelcomeBannerSkeleton() {
  return (
    <section className="relative overflow-hidden rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-[0_14px_50px_rgba(0,0,0,0.35)]">
      {/* subtle gradient wash */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-purple-500/10 via-transparent to-blue-500/10" />

      <div className="relative z-10 flex flex-wrap items-stretch gap-4 p-5 sm:p-6">
        {/* LEFT: text */}
        <div className="flex-[3] min-w-[260px] space-y-4">
          <div className="space-y-2">
            <SkeletonBlock className="h-7 w-[240px] sm:w-[320px]" />
            <SkeletonBlock className="h-4 w-[280px] sm:w-[420px]" />
          </div>

          <div className="flex flex-wrap gap-2">
            <SkeletonBlock className="h-8 w-24" />
            <SkeletonBlock className="h-8 w-28" />
            <SkeletonBlock className="h-8 w-20" />
          </div>

          <div className="mt-2 space-y-2">
            <SkeletonBlock className="h-3 w-[90%]" />
            <SkeletonBlock className="h-3 w-[70%]" />
          </div>
        </div>

        {/* RIGHT: stats (mobile becomes row) */}
        <div className="flex-1 min-w-[240px]">
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-2">
            <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
              <SkeletonBlock className="h-3 w-20" />
              <SkeletonBlock className="mt-3 h-6 w-16" />
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
              <SkeletonBlock className="h-3 w-24" />
              <SkeletonBlock className="mt-3 h-6 w-14" />
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
              <SkeletonBlock className="h-3 w-28" />
              <SkeletonBlock className="mt-3 h-6 w-20" />
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
              <SkeletonBlock className="h-3 w-20" />
              <SkeletonBlock className="mt-3 h-6 w-12" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
